var map = {
	"./8457509975922_1d7ecb565808f554a273_512.png": 98,
	"./Git_icon.svg.png": 455,
	"./Moby-logo.png": 762,
	"./Visual_Studio_Code_1.35_icon.svg.png": 506,
	"./logo-glyph.png": 3
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;